// Popular crypto coins database - Binance USDT pairs
// This provides a stable list of coins to track

// Categories for filtering
export const CATEGORIES = {
    all: { label: 'Tümü', labelEn: 'All' },
    top: { label: 'Top 10', labelEn: 'Top 10' },
    layer1: { label: 'Layer 1', labelEn: 'Layer 1' },
    layer2: { label: 'Layer 2', labelEn: 'Layer 2' },
    defi: { label: 'DeFi', labelEn: 'DeFi' },
    meme: { label: 'Meme', labelEn: 'Meme' },
    gaming: { label: 'Gaming', labelEn: 'Gaming' },
    ai: { label: 'AI', labelEn: 'AI' },
};

export const COIN_DATABASE = [
    // Top coins by market cap
    { symbol: 'BTCUSDT', name: 'Bitcoin', shortName: 'BTC', category: 'top' },
    { symbol: 'ETHUSDT', name: 'Ethereum', shortName: 'ETH', category: 'top' },
    { symbol: 'BNBUSDT', name: 'BNB', shortName: 'BNB', category: 'top' },
    { symbol: 'XRPUSDT', name: 'XRP', shortName: 'XRP', category: 'top' },
    { symbol: 'SOLUSDT', name: 'Solana', shortName: 'SOL', category: 'top' },
    { symbol: 'ADAUSDT', name: 'Cardano', shortName: 'ADA', category: 'top' },
    { symbol: 'DOGEUSDT', name: 'Dogecoin', shortName: 'DOGE', category: 'meme' },
    { symbol: 'TRXUSDT', name: 'TRON', shortName: 'TRX', category: 'layer1' },
    { symbol: 'AVAXUSDT', name: 'Avalanche', shortName: 'AVAX', category: 'layer1' },
    { symbol: 'LINKUSDT', name: 'Chainlink', shortName: 'LINK', category: 'defi' },

    // Layer 1 & Layer 2
    { symbol: 'DOTUSDT', name: 'Polkadot', shortName: 'DOT', category: 'layer1' },
    { symbol: 'MATICUSDT', name: 'Polygon', shortName: 'MATIC', category: 'layer2' },
    { symbol: 'NEARUSDT', name: 'NEAR Protocol', shortName: 'NEAR', category: 'layer1' },
    { symbol: 'APTUSDT', name: 'Aptos', shortName: 'APT', category: 'layer1' },
    { symbol: 'SUIUSDT', name: 'Sui', shortName: 'SUI', category: 'layer1' },
    { symbol: 'ATOMUSDT', name: 'Cosmos', shortName: 'ATOM', category: 'layer1' },
    { symbol: 'ICPUSDT', name: 'Internet Computer', shortName: 'ICP', category: 'layer1' },
    { symbol: 'ETCUSDT', name: 'Ethereum Classic', shortName: 'ETC', category: 'layer1' },
    { symbol: 'FILUSDT', name: 'Filecoin', shortName: 'FIL', category: 'layer1' },
    { symbol: 'ARBUSDT', name: 'Arbitrum', shortName: 'ARB', category: 'layer2' },
    { symbol: 'OPUSDT', name: 'Optimism', shortName: 'OP', category: 'layer2' },

    // DeFi
    { symbol: 'UNIUSDT', name: 'Uniswap', shortName: 'UNI', category: 'defi' },
    { symbol: 'AAVEUSDT', name: 'Aave', shortName: 'AAVE', category: 'defi' },
    { symbol: 'MKRUSDT', name: 'Maker', shortName: 'MKR', category: 'defi' },
    { symbol: 'LDOUSDT', name: 'Lido DAO', shortName: 'LDO', category: 'defi' },
    { symbol: 'CRVUSDT', name: 'Curve', shortName: 'CRV', category: 'defi' },
    { symbol: 'SNXUSDT', name: 'Synthetix', shortName: 'SNX', category: 'defi' },
    { symbol: 'COMPUSDT', name: 'Compound', shortName: 'COMP', category: 'defi' },
    { symbol: 'SUSHIUSDT', name: 'SushiSwap', shortName: 'SUSHI', category: 'defi' },
    { symbol: '1INCHUSDT', name: '1inch', shortName: '1INCH', category: 'defi' },

    // Meme coins
    { symbol: 'SHIBUSDT', name: 'Shiba Inu', shortName: 'SHIB', category: 'meme' },
    { symbol: 'PEPEUSDT', name: 'Pepe', shortName: 'PEPE', category: 'meme' },
    { symbol: 'FLOKIUSDT', name: 'Floki', shortName: 'FLOKI', category: 'meme' },
    { symbol: 'BONKUSDT', name: 'Bonk', shortName: 'BONK', category: 'meme' },
    { symbol: 'WIFUSDT', name: 'dogwifhat', shortName: 'WIF', category: 'meme' },

    // Gaming & Metaverse
    { symbol: 'SANDUSDT', name: 'The Sandbox', shortName: 'SAND', category: 'gaming' },
    { symbol: 'MANAUSDT', name: 'Decentraland', shortName: 'MANA', category: 'gaming' },
    { symbol: 'AXSUSDT', name: 'Axie Infinity', shortName: 'AXS', category: 'gaming' },
    { symbol: 'GALAUSDT', name: 'Gala', shortName: 'GALA', category: 'gaming' },
    { symbol: 'ENJUSDT', name: 'Enjin Coin', shortName: 'ENJ', category: 'gaming' },
    { symbol: 'IMXUSDT', name: 'Immutable X', shortName: 'IMX', category: 'gaming' },

    // AI & Data
    { symbol: 'FETUSDT', name: 'Fetch.ai', shortName: 'FET', category: 'ai' },
    { symbol: 'AGIXUSDT', name: 'SingularityNET', shortName: 'AGIX', category: 'ai' },
    { symbol: 'OCEANUSDT', name: 'Ocean Protocol', shortName: 'OCEAN', category: 'ai' },
    { symbol: 'RENDERUSDT', name: 'Render', shortName: 'RENDER', category: 'ai' },
    { symbol: 'GRTUSDT', name: 'The Graph', shortName: 'GRT', category: 'ai' },

    // Other Layer 1s
    { symbol: 'LTCUSDT', name: 'Litecoin', shortName: 'LTC', category: 'layer1' },
    { symbol: 'BCHUSDT', name: 'Bitcoin Cash', shortName: 'BCH', category: 'layer1' },
    { symbol: 'XLMUSDT', name: 'Stellar', shortName: 'XLM', category: 'layer1' },
    { symbol: 'ALGOUSDT', name: 'Algorand', shortName: 'ALGO', category: 'layer1' },
    { symbol: 'VETUSDT', name: 'VeChain', shortName: 'VET', category: 'layer1' },
    { symbol: 'HBARUSDT', name: 'Hedera', shortName: 'HBAR', category: 'layer1' },
    { symbol: 'QNTUSDT', name: 'Quant', shortName: 'QNT', category: 'layer1' },
    { symbol: 'EGLDUSDT', name: 'MultiversX', shortName: 'EGLD', category: 'layer1' },
    { symbol: 'INJUSDT', name: 'Injective', shortName: 'INJ', category: 'defi' },
    { symbol: 'FTMUSDT', name: 'Fantom', shortName: 'FTM', category: 'layer1' },

    // Others popular
    { symbol: 'XMRUSDT', name: 'Monero', shortName: 'XMR', category: 'layer1' },
    { symbol: 'EOSUSDT', name: 'EOS', shortName: 'EOS', category: 'layer1' },
    { symbol: 'THETAUSDT', name: 'Theta', shortName: 'THETA', category: 'layer1' },
    { symbol: 'FLOWUSDT', name: 'Flow', shortName: 'FLOW', category: 'gaming' },
    { symbol: 'CHZUSDT', name: 'Chiliz', shortName: 'CHZ', category: 'gaming' },
    { symbol: 'APEUSDT', name: 'ApeCoin', shortName: 'APE', category: 'meme' },
    { symbol: 'ZILUSDT', name: 'Zilliqa', shortName: 'ZIL', category: 'layer1' },
    { symbol: 'RUNEUSDT', name: 'THORChain', shortName: 'RUNE', category: 'defi' },
    { symbol: 'KAVAUSDT', name: 'Kava', shortName: 'KAVA', category: 'defi' },
    { symbol: 'MINAUSDT', name: 'Mina', shortName: 'MINA', category: 'layer1' },
    { symbol: 'ROSEUSDT', name: 'Oasis', shortName: 'ROSE', category: 'layer1' },
    { symbol: 'WOOUSDT', name: 'WOO', shortName: 'WOO', category: 'defi' },
    { symbol: 'GMXUSDT', name: 'GMX', shortName: 'GMX', category: 'defi' },
    { symbol: 'CFXUSDT', name: 'Conflux', shortName: 'CFX', category: 'layer1' },
    { symbol: 'STXUSDT', name: 'Stacks', shortName: 'STX', category: 'layer2' },
    { symbol: 'SEIUSDT', name: 'Sei', shortName: 'SEI', category: 'layer1' },
    { symbol: 'TIAUSDT', name: 'Celestia', shortName: 'TIA', category: 'layer1' },
    { symbol: 'JUPUSDT', name: 'Jupiter', shortName: 'JUP', category: 'defi' },
    { symbol: 'PENDLEUSDT', name: 'Pendle', shortName: 'PENDLE', category: 'defi' },
    { symbol: 'ENAUSDT', name: 'Ethena', shortName: 'ENA', category: 'defi' },
];

// Get coin info by symbol
export const getCoinInfo = (symbol) => {
    return COIN_DATABASE.find(coin => coin.symbol === symbol);
};

// Get all symbols for WebSocket subscription
export const getAllSymbols = () => {
    return COIN_DATABASE.map(coin => coin.symbol.toLowerCase());
};

// Get coins by category
export const getCoinsByCategory = (category) => {
    if (category === 'all') return COIN_DATABASE;
    return COIN_DATABASE.filter(coin => coin.category === category);
};

export default COIN_DATABASE;
